/**
 * @format
 * @fieldat
 */

import { useContext, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import Master from '../Layouts/Master';
import ModalCustom from '../../Shared/Components/ModalCustom';
import { EventContext } from '../../Contexts/EventContext';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import Pagination from '../../Shared/Components/Pagination';

const Field = () => {
	const eventContext = useContext(EventContext);
	const { search } = useLocation();
	const [loading, setLoading] = useState(false);
	const [removeLoading, setRemoveLoading] = useState(false);
	const [fieldRemoveId, setFieldRemoveId] = useState();
	const [modalIsOpen, setModalIsOpen] = useState(false);

	useEffect(() => {
		getField();
	}, [search]);
	const getField = async () => {
		setLoading(true);
		await useApi.get(
			`/sport-field/${search}`,
			{},
			(res) => {
				eventContext.sportFields = res.data;
				setLoading(false);
			},
			(err) => {
				setLoading(false);
				error('هنگام دریافت اطلاعات خطایی رخ داده است');
			},
		);
	};
	const removeField = async (fieldId) => {
		setRemoveLoading(true);

		await useApi.delete(
			`/sport-field/${fieldId}`,
			{},
			(res) => {
				success('رشته مورد نظر با موفقیت حذف شد');
				setRemoveLoading(false);
				setModalIsOpen(false);
				getField();
			},
			(err) => {
				setRemoveLoading(false);
				setLoading(false);
				error('حذف به علت خطا انجام نشد');
			},
		);
	};

	const getGender = (gender) => {
		const genders = [
			{ key: 0, value: 'هردو' },
			{ key: 1, value: 'مرد' },
			{ key: 2, value: 'زن' },
		];

		return genders.find((g) => g.key == gender)?.value;
	};

	return (
		<Master>
			<div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
				<div className='d-flex flex-row mt-2'>
					<i className='fad fa-list f-20 text-secondary mx-2'></i>
					<h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
						لیست رشته ها
					</h1>
				</div>
				<Link
					to='/panel/sport-field/create'
					className='d-flex flex-row btn btn-outline-info '>
					<i className='fad fa-plus f-16 mx-2'></i>
					<span className='f-13'>ایجاد رشته</span>
				</Link>
			</div>
			<div className='w-100 overflow-auto'>
				{eventContext.sportFields?.data?.length > 0 ? (
					<table className='table table-hover'>
						<thead>
							<tr>
								<th>#</th>
								<th>عنوان</th>
								<th>جنسیت</th>
								<th>عملیات</th>
							</tr>
						</thead>
						<tbody>
							{eventContext.sportFields?.data?.map((item) => (
								<tr key={item.id}>
									<th>{item.id}</th>
									<td>{item.name}</td>
									<td>{getGender(item.gender)}</td>
									<td>
										<div className='d-flex flex-row'>
											<Link
												to={`/panel/sport-field/edit/${item.id}`}
												className='mx-2'>
												ویرایش
											</Link>
											<Link
												className='mx-2'
												to='#'
												onClick={(e) => {
													e.preventDefault();
													setFieldRemoveId(item.id);
													setModalIsOpen(true);
												}}>
												حذف
											</Link>
										</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				) : (
					<div className='d-flex flex-row justify-content-center border p-3 my-3	'>
						<i className='fad fa-plus f-16 mx-2 text-secondary'></i>
						<span className='f-13 font-weight-bold text-secondary'>
							برای ایجاد رشته بر روی منوی ایجاد رشته کلیک کنید
						</span>
					</div>
				)}
			</div>
			<div className='w-100 mt-4 d-flex'>
				<Pagination meta={eventContext.sportFields?.meta} />
			</div>
			<ModalCustom modalIsOpen={modalIsOpen}>
				<div className='d-flex flex-row border-bottom pb-2'>
					<i className='fad fa-warning f-20 mx-2'></i>
					<span className=''>آیا از حذف رشته مطمئنید‌؟</span>
				</div>
				<div className='d-flex flex-row justify-content-around my-3'>
					<button
						onClick={() => setModalIsOpen(false)}
						className='btn btn-danger w-48 f-13'>
						لغو
					</button>
					<button
						onClick={() => removeField(fieldRemoveId)}
						className='btn btn-success w-48 f-13'>
						{removeLoading ? (
							<div
								className='spinner-border spinner-border-sm text-white mb-1'
								role='status'></div>
						) : (
							'بله'
						)}
					</button>
				</div>
			</ModalCustom>
		</Master>
	);
};

export default Field;
